
import {of as observableOf } from 'rxjs';
import { Injectable, inject } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

import { catchError } from 'rxjs/operators';
import { RavenErrorLoggingService } from './raven-logging.service';
import { errorMessage } from './error-message';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private snackBar = inject(MatSnackBar);
  private errorService = inject(RavenErrorLoggingService);


  // Callers often hand over the caught error itself; errorMessage keeps "ApolloError: " out of the toast.
  addError(message: unknown) {
    this.snackBarWrapper(errorMessage(message), { panelClass: ['error'] });
  }

  clearErrors() {
    this.snackBar.dismiss();
  }

  notify(message: string) {
    this.snackBarWrapper(message, { duration: 3000 });
  }

  snackBarWrapper(message: string, config?: MatSnackBarConfig) {
    this.snackBar.open(message, 'x', config);
  }

  // Note, we are now relying on a global graphqlErrorLink formatting the deeper error.errors.0.message into the main error.message
  buildGraphqlErrorMsg(error: any, msgPrefix?: string) {
    const message = errorMessage(error).trim();
    return msgPrefix
      ? `${msgPrefix} - ${message}`
      : message;
  }

  addGraphqlError(error: any, msgPrefix?: string) {
    this.errorService.logError(error);
    const errorMsg = this.buildGraphqlErrorMsg(error, msgPrefix);
    this.addError(errorMsg);
    console.log({errorMsg});
    return errorMsg;
  }

  catchGraphError(msgPrefix: string, defaultValue: any) {
    return catchError(err => {

      this.addGraphqlError(err, msgPrefix);
      return observableOf(defaultValue);
    })
  }

  addHttpError(error: HttpErrorResponse, msgPrefix?: string) {
    this.errorService.logError(error);
    const message = error.error?.message || error.message;
    const errorMsg = msgPrefix
      ? `${msgPrefix} - ${message}`
      : message;
    this.addError(errorMsg);
    return errorMsg;
  }

}
